export default {
  trends: {
    title: "Trends",
    navigation: {
      gameSummary: "Spielzusammenfassung",
    },
    tabs: {
      player: "Spieler",
      team: "Team",
      parlay: "Kombiwette",
      sgp: "SGP",
      stats: "Stats",
    },
    help: {
      title: "Trends",
      description: "Linemate nutzt diese Signale, um Stärke und Kontext jedes Trends zu zeigen.",
      items: {
        recentForm: "Trefferquote der aktuellen Form",
        headToHead: "Trefferquote im direkten Vergleich",
        homeAway: "Trefferquote in Heim- und Auswärtsspielen",
        starter: "Trefferquote als Starter (Linemate+)",
        injuryImpact: "Einfluss von Teamkollegen-Verletzungen (Linemate+)",
        opponentRank: "Defensivrang des Gegners (Linemate+)",
      },
    },
    empty: {
      noTrendsAvailable: "Keine Trends verfügbar",
      clearFilters: "Filter löschen",
      offseasonTitle: "Derzeit Offseason",
      minimumGames: "Mindestens 3 Spiele erforderlich",
    },
    analysis: {
      title: "Trend-Analyse",
      viewProfile: "Profil anzeigen",
      addToMyPicks: "Zu Meine Tipps hinzufügen",
      removeFromMyPicks: "Aus Meine Tipps entfernen",
      addParlayToMyPicks: "Kombiwette zu Meine Tipps hinzufügen",
      removeParlay: "Kombiwette entfernen",
      addLegToMyPicks: "Leg zu Meine Tipps hinzufügen",
      removeLegFromMyPicks: "Leg aus Meine Tipps entfernen",
      sections: {
        playerForm: "Spielerform",
        playerPerformance: "Spielerleistung",
        teamPerformance: "Teamleistung",
        teamForm: "Teamform",
        startingLineup: "Startaufstellung",
        injuries: "Verletzungen",
        startingPitcher: "Starting Pitcher",
        batterVsPitcher: "Batter vs Pitcher",
        opponentDefensiveRank: "Defensivrang des Gegners",
        weather: "Wetter",
        lockedAdvancedTools: "Mehr mit Linemate+",
        parlayLegs: "Legs",
      },
      labels: {
        status: "Status",
        player: "Spieler",
        type: "Typ",
        viewGames: "Spiele ansehen",
        quickCheckout: "Schnell-Checkout",
        showAll: "Alle anzeigen",
        close: "Schließen",
        openOnProvider: "Auf {{provider}} öffnen",
        visitProvider: "{{provider}} besuchen",
        recentForm: "Aktuelle Form",
        headToHead: "Direkter Vergleich",
        location: "Ort",
        lastFive: "Letzte 5",
        asStarter: "Als Starter",
        startingPitcher: "Starting Pitcher",
        overallRank: "Gesamtrang",
        positionalRank: "Positionsrang",
        confirmed: "Bestätigt",
        expected: "Erwartet",
        withoutPlayer: "Ohne {{player}}",
        rankVsPosition: "Rang vs {{position}}",
        impactOn: "Einfluss auf {{target}}",
        defensiveRankAgainst: "{{team}} Defensivrang ‧ {{betType}} gegen",
        vsPitcher: "vs {{pitcher}}",
        atBatsSummary: "{{value}} {{stat}} in {{atBats}} At Bats",
        gamesSuffix: " Spiele",
        noSignalsFound: "Keine Signale für diesen Trend gefunden",
        noStarterSignal: "Es gibt kein Starter-Signal",
        noStartingLineupsYet: "Es gibt noch keine Startaufstellungen",
        noInjuryReportSignal: "Es gibt kein Verletzungsbericht-Signal",
        noInjuries: "Derzeit gibt es keine Verletzungen",
      },
      summaryCards: {
        recentForm: "Aktuelle Form",
        headToHead: "Direkter Vergleich",
        homeSplit: "Heim-Split",
        awaySplit: "Auswärts-Split",
        recordGames: "{{record}} Spiele",
        recordVs: "{{record}} vs {{opponent}}",
        recordAtHome: "{{record}} zu Hause",
        recordAway: "{{record}} auswärts",
      },
      paywall: {
        title: "Schalte die vollständige Trend-Analyse frei",
        body: "Sieh den Einfluss jedes erweiterten Signals.",
      },
      preview: {
        injuryImpact: "Verletzungsbericht",
        opponentRank: "Defensivrang des Gegners",
        recordPlaceholder: "100% ⋅ 00 der letzten 00 Spiele",
        opponentRankPlaceholder: "00. • Positiv",
        weatherPlaceholder: "Bewölkt",
      },
      weatherDirections: {
        inToOut: "Von innen nach außen",
        outToRight: "Von außen nach rechts",
        outToIn: "Von außen nach innen",
        inFromLeft: "Von links hinein",
        inFromRight: "Von rechts hinein",
        leftToRight: "Von links nach rechts",
        outToLeft: "Von außen nach links",
        rightToLeft: "Von rechts nach links",
        unknown: "Unbekannt",
      },
      hints: {
        addTrendToMyPicks: "Füge diesen Trend zu Meine Tipps hinzu, um deine Wette zu platzieren",
        swipeToAddTrend: "Wische nach links, um schnell einen Trend zu Meine Tipps hinzuzufügen.",
        swipeAddLabel: "Hinzufügen",
      },
      imageImport: {
        noPicksFound: "Keine Tipps gefunden",
        noPicksBody: "Wir konnten keine Tipps aus diesem Bild zuordnen.",
        analyze: "Analysieren",
      },
      gamelog: {
        title: "Gamelog",
        titleWithout: "Gespielte Spiele ohne {{name}}",
        chips: {
          last10: "Letzte 10",
          headToHead: "Direkter Vergleich",
          homeSplits: "Heim-Splits",
          awaySplits: "Auswärts-Splits",
          versusPitcher: "vs. {{pitcher}}",
        },
        headers: {
          hit: "Hit",
          date: "Datum",
          versus: "Gegen",
          result: "Ergebnis",
          comp: "Wettb.",
        },
      },
    },
    stats: {
      sections: {
        records: "Bilanzen",
        headToHead: "Direkter Vergleich",
        last5Games: "Letzte 5 Spiele",
        rankings: "Rankings",
        injuries: "Verletzungen",
        gameDetails: "Spieldetails",
      },
      picker: {
        season: "Saison",
        last5: "Letzte 5",
        headToHead: "Direkter Vergleich",
      },
      rows: {
        recentForm: "Letzte 5 Spiele",
        season: "Weltmeisterschaft 2026",
        overall: "Gesamt",
        home: "Heim",
        away: "Auswärts",
      },
      rankings: {
        for: "FÜR",
        against: "GEGEN",
      },
    },
  },
};
